<div class="card" style="position: relative">
    <p-toast></p-toast>
    <span *ngIf="quote" class="page-title"><i class="pi pi-id-card page-title-icon"></i></span>
    <div class="customer-details-container" *ngIf="quote; else loadingCustomer">
        <div class="divider-wrapper">
            <hr />
        </div>
        <div class="customer-details-inner">
            <div class="kyc-wrapper">
                <p-accordion [(activeIndex)]="activeIndex">
                    <p-accordionTab header="Comprehensive Quotation Details">
                        <div class="kyc-inner">
                            <div class="kyc-customer-detail">
                                <h5 class="kyc-card-title">Customer Details</h5>
                                <div class="kyc-data-row">

                                    <div class="kyc-data-row">
                                        <div class="kyc-data">
                                            <span class="kyc-value">{{
                                                quote['motorInsurancePolicy']['client']['firstName']
                                                }}</span>
                                            <span class="kyc-title">Customer First Name</span>
                                        </div>
                                    </div>
                                    <div class="kyc-data-row">
                                        <div class="kyc-data">
                                            <span class="kyc-value">{{
                                                quote['motorInsurancePolicy']['client']['lastName']
                                                }}</span>
                                            <span class="kyc-title">Customer Last Name</span>
                                        </div>
                                    </div>
                                    <div class="kyc-data-row">
                                        <div class="kyc-data">
                                            <span class="kyc-value">{{
                                                quote['motorInsurancePolicy']['client']['email']
                                                }}</span>
                                            <span class="kyc-title">Customer Email</span>
                                        </div>
                                    </div>
                                    <div class="kyc-data-row">
                                        <div class="kyc-data">
                                            <span class="kyc-value">{{
                                                quote['motorInsurancePolicy']['client']['mobileNumber']
                                                }}</span>
                                            <span class="kyc-title">Customer Mobile Number</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="kyc-customer-detail">
                                <h5 class="kyc-card-title">Policy Details</h5>
                                <div class="kyc-data-row">
                                    <div class="kyc-data-row">
                                        <div class="kyc-data">
                                            <span class="kyc-value">{{
                                                quote['motorInsurancePolicy']['insuranceType']
                                                }}</span>
                                            <span class="kyc-title">Insurance Type</span>
                                        </div>
                                    </div>
                                    <div class="kyc-data-row">
                                        <div class="kyc-data">
                                            <span class="kyc-value">{{
                                                quote['motorInsurancePolicy']['dateCreated'] | date: 'medium'
                                                }}</span>
                                            <span class="kyc-title">Policy Creation Date</span>
                                        </div>
                                    </div>
                                    <div class="kyc-data-row">
                                        <div class="kyc-data">
                                            <span class="kyc-value">{{
                                                quote['motorInsurancePolicy']['status']
                                                }}</span>
                                            <span class="kyc-title">Policy Status</span>
                                        </div>
                                    </div>

                                    <div class="kyc-data-row">
                                        <div class="kyc-data">
                                            <span class="kyc-value">{{
                                                quote['motorInsurancePolicy']['totalBaseAmount'] |currency:'USD'
                                                }}</span>
                                            <span class="kyc-title">Total Premium Amount</span>
                                        </div>
                                    </div>
                                    <div class="kyc-data-row">
                                        <div class="kyc-data">
                                            <span class="kyc-value">{{
                                                quote['motorInsurancePolicy']['channel']
                                                }}</span>
                                            <span class="kyc-title">Channel</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <br />
                        <button pButton severity="secondary" icon="pi pi-arrow-left"
                            routerLink="/home/comprehensive-approvals">&nbsp;Back</button>
                    </p-accordionTab>
                    <p-accordionTab header="Vehicle Images">
                        @if (quote['vehicleImages'] && quote['vehicleImages'].length > 0) {
                        <div class="flex flex-wrap gap-4">
                            @for (vehicleImage of quote['vehicleImages']; track vehicleImage) {
                            <div class="vehicle-image-container flex flex-column gap-2" [style]="{cursor: pointer}"
                                (click)="viewImage(vehicleImage.imageAngle, vehicleImage.imageUrl)">
                                <img [src]="getSafeUrl(vehicleImage.imageUrl)" [style]="{cursor: pointer}"
                                    (click)="viewImage(vehicleImage.imageAngle, vehicleImage.imageUrl)" alt="Vehicle"
                                    width="200" height="200" class="vehicle-image" />
                                <span class="image-position">Angle :&nbsp;{{ vehicleImage.imageAngle }}</span>
                            </div>
                            }
                        </div>
                        <hr />
                        } @else {
                        <p class="mb-3">No images were uploaded</p>
                        <hr />
                        }

                        <div class="flex gap-2 mt-4">
                            <button pButton severity="secondary" icon="pi pi-arrow-left"
                                routerLink="/home/comprehensive-approvals">&nbsp;Back</button>
                            <button pButton severity="warning" (click)="revokeReasonVisible=true"
                                icon="pi pi-times">&nbsp;Revoke Policy</button>
                        </div>
                    </p-accordionTab>

                </p-accordion>
            </div>
        </div>
    </div>

    <!-- Dialog for displaying the clicked image on a larger scale -->
    <p-dialog header="View Image" [(visible)]="viewImageVisible" [modal]="true"
        [style]="{ width: screenWidth < 900 ? '75vw' : '35vw' }" [closable]="true" [dismissableMask]="true"
        [baseZIndex]="10000" appendTo="body">

        <div class="dialog-content">
            <img [src]="selectedImageUrl" alt="Vehicle" style="width: 100%; border-radius: 8px;" />

            <p>Angle :&nbsp;{{ selectedImageAngle }}</p>
        </div>
    </p-dialog>

    <!-- Dialog for capturing revoke reason -->
    <p-dialog header="Revoke Policy" [(visible)]="revokeReasonVisible" [modal]="true"
        [style]="{ width: screenWidth < 900 ? '75vw' : '35vw' }" [closable]="true" [dismissableMask]="true"
        [baseZIndex]="10000" appendTo="body">

        <div class="dialog-content" [formGroup]="revokeForm">
            <textarea placeholder="Enter the reason for revoking policy" pInputTextarea rows="4"
                [style]="{minWidth: '100%',marginTop: '.75rem'}" formControlName="revokeReason"></textarea>
        </div>
        <div class="dialog-actions mt-3 flex gap-2">
            <button pButton severity="secondary" (click)="revokeReasonVisible=false"
                icon="pi pi-times">&nbsp;Cancel</button>
            <button pButton severity="danger" (click)="revokePolicy()" [loading]="revokingQuote" icon="pi pi-check"
                [disabled]="revokeForm.invalid">&nbsp;Confirm Revoke</button>
        </div>
    </p-dialog>

    <ng-template #loadingCustomer>
        <p-dialog [(visible)]="visible" [modal]="true" [closable]="false"
            [style]="{ width: screenWidth < 900 ? '65vw' : '35vw' }">
            <app-loading [message]="loadingMessage"></app-loading>
        </p-dialog>
    </ng-template>
</div>